import { ComponentType, forwardRef, ReactElement, ReactNode, Ref } from 'react';
import { TransitionProps } from '@mui/material/transitions';
import { IconButton, Slide, SvgIcon, Typography } from '@mui/material';
import clsx from 'clsx';
import useStyles from './styles';

import { Dialog as MuiDialog } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../icons/assets/cancel.svg';

export interface DialogProps {
  children?: ReactNode;
  title?: string;
  size?: 'small' | 'medium' | 'large';
  closeable?: boolean;
  popDialog?: any;
}
const Transition = forwardRef(function Transition(
  props: TransitionProps & { children: ReactElement },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const BaseDialog: ComponentType<DialogProps> = ({
  children,
  size = 'medium',
  title,
  closeable = true,
  popDialog,
  ...props
}) => {
  const classes = useStyles();

  return (
    <MuiDialog
      open
      onClose={popDialog}
      TransitionComponent={Transition}
      classes={{ root: classes.root, paper: clsx(classes.paper, { [classes[size]]: size }) }}
      {...props}
    >
      {closeable && (
        <IconButton onClick={popDialog} className={classes.close} size="small">
          <SvgIcon component={CloseIcon} viewBox="0 0 24 24" />
        </IconButton>
      )}
      {title && (
        <Typography variant="h1" component="h6" mb={2} mr={4}>
          {title}
        </Typography>
      )}
      {children}
    </MuiDialog>
  );
};
